import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';
import { ChatRoomType } from 'src/types/apps/messages';

export interface CreateChatRoomBody {
  type: ChatRoomType;
  target_id: number[];
  /** Required for `stadium_private`. Also used for `private` rooms opened from
   * a stadium-scoped screen. `match`/`stadium` rooms derive stadium server-side. */
  stadium_id?: number;
}

export interface CreateChatRoomResponse {
  chat_id: string;
  status: number;
}

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<CreateChatRoomResponse, CreateChatRoomBody>({
    query: (body) => ({
      url: 'v4/chat-firebase/chat',
      method: 'POST',
      body,
    }),
  });
